
export const SITE = {
  company: 'Northface Irrigation Repair and Services LLC',
  shortName: 'Northface Irrigation',
  phone: '(972) 371-9983',
  phoneHref: 'tel:+19723719983',
  smsHref: 'sms:+19723719983',
  email: 'northfaceirrigationrepair@gmail.com',
  emailHref: 'mailto:northfaceirrigationrepair@gmail.com',
  license: 'LI0026988',
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/4T7KGzusRY6Q3CL2Ed1P3t/Photoroom_20260719_125319.png',
  heroImageUrl:
    'https://cdn.magicpatterns.com/uploads/oTshLW9DkfHudXv7U321i4/irrigation2.png',
  serviceAreas: [
    'Fate',
    'Allen',
    'Heath',
    'Lavon',
    'Lucas',
    'Plano',
    'Wylie',
    'Murphy',
    'Parker',
    'Sachse',
    'Garland',
    'Rowlett',
    'Mesquite',
    'Rockwall',
    'Richardson',
    'Forney',
    'Sunnyvale',
  ],
  tagline: 'We Install It. We Insure It. We Guarantee It Works.',
}
